<template>
    <section class="container lg:w-1/4 justify-center  ml-auto mr-auto h-auto lg:mt-32 mb:16 content-center">
        <h1 class="title text-center text-4xl">Connexion</h1>
    <div class="bg-white shadow-xl rounded px-8 pt-6 pb-8 mb-4 flex flex-col my-2 align-middle">

        <div class="-mx-3 md:flex mb-6">
            <div class="md:w-full px-3 mb-6 md:mb-0">
                <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-first-name">
                    Adresse mail
                </label>
                <input class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-red rounded py-3 px-4 mb-3" id="grid-first-name" type="email" placeholder="example@gmail.com">
<!--                <p class="text-red text-xs italic">Please fill out this field.</p>-->
            </div>
        </div>
        <div class="-mx-3 md:flex mb-6">
            <div class="md:w-full px-3">
                <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-password">
                    mot de passe
                </label>
                <input class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-3 px-4 mb-3" id="grid-password" type="password" placeholder="******************">
<!--                <p class="text-grey-dark text-xs italic">Make it as long and as crazy as you'd like</p>-->
            </div>
        </div>
        <div class="mb-2 mt-10 w-full   justify-center text-center relative  absolute inset-0 flex items-center justify-center">
            <button class=" w-1/2  justify-center bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 border border-blue-700 container text-center rounded flex text-center">

             Connection
            </button>
        </div>
        <p class="text-center text italic">Vous n'avez pas de compte? <router-link to="/login" class="hover:underline text-blue-600"> Enregistrez-vous</router-link> </p>
    </div>
    </section>
</template>

<script>
    export default {
        name: "Login"

    }
</script>

<style scoped>

</style>
